/*
 * @Author: zhangguoliang
 * @Date: 2022-11-17 10:29:19
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-11-27 10:28:59
 */
import { getCMS } from "@/api";
import { defineStore } from "pinia";

export const useStore = defineStore<
  string,
  { moreList: Record<string, any>[]; menu: any[] },
  Record<string, never>,
  { getMore: () => Promise<void>; setMenu: (menu: any[]) => void }
>("more", {
  state: () => ({
    moreList: [],
    menu: [],
  }),
  actions: {
    async getMore() {
      const res = await getCMS({
        pageNum: 1,
        pageSize: 10,
        Terminal: "pc",
        Port: 19,
      });
      this.moreList = res.rows;
    },
    setMenu(menu) {
      this.menu = menu;
    },
  },
});
